import { render, staticRenderFns } from "./ActionsMsgRow.vue?vue&type=template&id=a04a7a52"
import script from "./ActionsMsgRow.vue?vue&type=script&lang=js"
export * from "./ActionsMsgRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports